import { createRoute } from "../../../utils";

import { courseChapterBreadcrumbs, courseChaptersRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { IRole } from "@/interfaces";

const permission = [IRole.FACULTY_MEMBER];

const courseChaptersRouteMetadata: IRouteMetadataObj<
  typeof courseChaptersRoutesObj
> = {
  create: {
    title: "addNewChapter",
    lazy: () =>
      import(
        "@pages/facultyMemberPanel/courseManagement/courseChapters/form/page"
      ),
    mode: "create",
    permission,
  },
  edit: {
    title: "editChapterOf",
    lazy: () =>
      import(
        "@pages/facultyMemberPanel/courseManagement/courseChapters/form/page"
      ),
    mode: "edit",
    permission,
  },
  view: {
    title: "viewChapterOf",
    lazy: () =>
      import(
        "@pages/facultyMemberPanel/courseManagement/courseChapters/view/page"
      ),
    mode: "view",
    permission,
  },
};

export const courseChaptersRoutes = createRoute<typeof courseChaptersRoutesObj>(
  courseChaptersRoutesObj,
  courseChaptersRouteMetadata,
  courseChapterBreadcrumbs,
);
